"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const countries = [
    {
        country_code: "AX",
        country_name: "Åland Islands",
    },
    {
        country_code: "DZ",
        country_name: "Algeria",
    },
    {
        country_code: "AD",
        country_name: "Andorra",
    },
    {
        country_code: "AO",
        country_name: "Angola",
    },
    {
        country_code: "AI",
        country_name: "Anguilla",
    },
    {
        country_code: "AG",
        country_name: "Antigua and Barbuda",
    },
    {
        country_code: "AR",
        country_name: "Argentina",
    },
    {
        country_code: "AM",
        country_name: "Armenia",
    },
    {
        country_code: "AW",
        country_name: "Aruba",
    },
    {
        country_code: "AU",
        country_name: "Australia",
    },
    {
        country_code: "AT",
        country_name: "Austria",
    },
    {
        country_code: "AZ",
        country_name: "Azerbaijan",
    },
    {
        country_code: "BH",
        country_name: "Bahrain",
    },
    {
        country_code: "BD",
        country_name: "Bangladesh",
    },
    {
        country_code: "BE",
        country_name: "Belgium",
    },
    {
        country_code: "BM",
        country_name: "Bermuda",
    },
    {
        country_code: "BT",
        country_name: "Bhutan",
    },
    {
        country_code: "BO",
        country_name: "Bolivia, Plurinational State of",
    },
    {
        country_code: "BA",
        country_name: "Bosnia and Herzegovina",
    },
    {
        country_code: "BR",
        country_name: "Brazil",
    },
    {
        country_code: "BN",
        country_name: "Brunei Darussalam",
    },
    {
        country_code: "BG",
        country_name: "Bulgaria",
    },
    {
        country_code: "CM",
        country_name: "Cameroon",
    },
    {
        country_code: "CA",
        country_name: "Canada",
    },
    {
        country_code: "CV",
        country_name: "Cape Verde",
    },
    {
        country_code: "KY",
        country_name: "Cayman Islands",
    },
    {
        country_code: "CL",
        country_name: "Chile",
    },
    {
        country_code: "CO",
        country_name: "Colombia",
    },
    {
        country_code: "CK",
        country_name: "Cook Islands",
    },
    {
        country_code: "CR",
        country_name: "Costa Rica",
    },
    {
        country_code: "HR",
        country_name: "Croatia",
    },
    {
        country_code: "CY",
        country_name: "Cyprus",
    },
    {
        country_code: "CZ",
        country_name: "Czech Republic",
    },
    {
        country_code: "DK",
        country_name: "Denmark",
    },
    {
        country_code: "EG",
        country_name: "Egypt",
    },
    {
        country_code: "EE",
        country_name: "Estonia",
    },
    {
        country_code: "FK",
        country_name: "Falkland Islands (Malvinas)",
    },
    {
        country_code: "FO",
        country_name: "Faroe Islands",
    },
    {
        country_code: "FJ",
        country_name: "Fiji",
    },
    {
        country_code: "FI",
        country_name: "Finland",
    },
    {
        country_code: "FR",
        country_name: "France",
    },
    {
        country_code: "GF",
        country_name: "French Guiana",
    },
    {
        country_code: "PF",
        country_name: "French Polynesia",
    },
    {
        country_code: "GA",
        country_name: "Gabon",
    },
    {
        country_code: "GE",
        country_name: "Georgia",
    },
    {
        country_code: "DE",
        country_name: "Germany",
    },
    {
        country_code: "GI",
        country_name: "Gibraltar",
    },
    {
        country_code: "GR",
        country_name: "Greece",
    },
    {
        country_code: "GL",
        country_name: "Greenland",
    },
    {
        country_code: "GD",
        country_name: "Grenada",
    },
    {
        country_code: "GG",
        country_name: "Guernsey",
    },
    {
        country_code: "HK",
        country_name: "Hong Kong",
    },
    {
        country_code: "HU",
        country_name: "Hungary",
    },
    {
        country_code: "IS",
        country_name: "Iceland",
    },
    {
        country_code: "IN",
        country_name: "India",
    },
    {
        country_code: "ID",
        country_name: "Indonesia",
    },
    {
        country_code: "IE",
        country_name: "Ireland",
    },
    {
        country_code: "IM",
        country_name: "Isle of Man",
    },
    {
        country_code: "IL",
        country_name: "Israel",
    },
    {
        country_code: "IT",
        country_name: "Italy",
    },
    {
        country_code: "JP",
        country_name: "Japan",
    },
    {
        country_code: "JE",
        country_name: "Jersey",
    },
    {
        country_code: "KZ",
        country_name: "Kazakhstan",
    },
    {
        country_code: "KE",
        country_name: "Kenya",
    },
    {
        country_code: "KR",
        country_name: "Korea, Republic of",
    },
    {
        country_code: "KG",
        country_name: "Kyrgyzstan",
    },
    {
        country_code: "LV",
        country_name: "Latvia",
    },
    {
        country_code: "LI",
        country_name: "Liechtenstein",
    },
    {
        country_code: "LT",
        country_name: "Lithuania",
    },
    {
        country_code: "LU",
        country_name: "Luxembourg",
    },
    {
        country_code: "MO",
        country_name: "Macau",
    },
    {
        country_code: "MK",
        country_name: "Macedonia, the Former Yugoslav Republic of",
    },
    {
        country_code: "MY",
        country_name: "Malaysia",
    },
    {
        country_code: "MV",
        country_name: "Maldives",
    },
    {
        country_code: "MT",
        country_name: "Malta",
    },
    {
        country_code: "MX",
        country_name: "Mexico",
    },
    {
        country_code: "MD",
        country_name: "Moldova, Republic of",
    },
    {
        country_code: "MC",
        country_name: "Monaco",
    },
    {
        country_code: "ME",
        country_name: "Montenegro",
    },
    {
        country_code: "MA",
        country_name: "Morocco",
    },
    {
        country_code: "MZ",
        country_name: "Mozambique",
    },
    {
        country_code: "NA",
        country_name: "Namibia",
    },
    {
        country_code: "NL",
        country_name: "Netherlands",
    },
    {
        country_code: "NC",
        country_name: "New Caledonia",
    },
    {
        country_code: "NZ",
        country_name: "New Zealand",
    },
    {
        country_code: "NG",
        country_name: "Nigeria",
    },
    {
        country_code: "NO",
        country_name: "Norway",
    },
    {
        country_code: "PG",
        country_name: "Papua New Guinea",
    },
    {
        country_code: "PY",
        country_name: "Paraguay",
    },
    {
        country_code: "PE",
        country_name: "Peru",
    },
    {
        country_code: "PH",
        country_name: "Philippines",
    },
    {
        country_code: "PL",
        country_name: "Poland",
    },
    {
        country_code: "PT",
        country_name: "Portugal",
    },
    {
        country_code: "QA",
        country_name: "Qatar",
    },
    {
        country_code: "RE",
        country_name: "Réunion",
    },
    {
        country_code: "RO",
        country_name: "Romania",
    },
    {
        country_code: "BL",
        country_name: "Saint Barthélemy",
    },
    {
        country_code: "SH",
        country_name: "Saint Helena, Ascension and Tristan da Cunha",
    },
    {
        country_code: "KN",
        country_name: "Saint Kitts and Nevis",
    },
    {
        country_code: "LC",
        country_name: "Saint Lucia",
    },
    {
        country_code: "MF",
        country_name: "Saint Martin (French part)",
    },
    {
        country_code: "PM",
        country_name: "Saint Pierre and Miquelon",
    },
    {
        country_code: "VC",
        country_name: "Saint Vincent and the Grenadines",
    },
    {
        country_code: "SM",
        country_name: "San Marino",
    },
    {
        country_code: "ST",
        country_name: "Sao Tome and Principe",
    },
    {
        country_code: "SA",
        country_name: "Saudi Arabia",
    },
    {
        country_code: "SN",
        country_name: "Senegal",
    },
    {
        country_code: "RS",
        country_name: "Serbia",
    },
    {
        country_code: "SC",
        country_name: "Seychelles",
    },
    {
        country_code: "SG",
        country_name: "Singapore",
    },
    {
        country_code: "SK",
        country_name: "Slovakia",
    },
    {
        country_code: "SI",
        country_name: "Slovenia",
    },
    {
        country_code: "SB",
        country_name: "Solomon Islands",
    },
    {
        country_code: "ZA",
        country_name: "South Africa",
    },
    {
        country_code: "ES",
        country_name: "Spain",
    },
    {
        country_code: "LK",
        country_name: "Sri Lanka",
    },
    {
        country_code: "SZ",
        country_name: "Swaziland",
    },
    {
        country_code: "SE",
        country_name: "Sweden",
    },
    {
        country_code: "CH",
        country_name: "Switzerland",
    },
    {
        country_code: "TW",
        country_name: "Taiwan, Province of China",
    },
    {
        country_code: "TJ",
        country_name: "Tajikistan",
    },
    {
        country_code: "TH",
        country_name: "Thailand",
    },
    {
        country_code: "TO",
        country_name: "Tonga",
    },
    {
        country_code: "TR",
        country_name: "Turkey",
    },
    {
        country_code: "TM",
        country_name: "Turkmenistan",
    },
    {
        country_code: "AE",
        country_name: "United Arab Emirates",
    },
    {
        country_code: "GB",
        country_name: "United Kingdom",
    },
    {
        country_code: "US",
        country_name: "United States",
    },
    {
        country_code: "UA",
        country_name: "Ukraine",
    },
    {
        country_code: "UY",
        country_name: "Uruguay",
    },
    {
        country_code: "UZ",
        country_name: "Uzbekistan",
    },
    {
        country_code: "VN",
        country_name: "Vietnam",
    },
    {
        country_code: "ZM",
        country_name: "Zambia",
    },
];
exports.default = countries;
//# sourceMappingURL=countries.js.map